module.exports = __webpack_public_path__ + "assets/img/deco-3.e1f58d07.png";